import _objectSpread from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
// 其他支付类型
import { appInfo, CompareVersion } from '@/utils/utils';
import App from '@/utils/app';
import auth from '@/utils/auth';
import store from '@/store';

// export const ZFB_PAY_ID = '10000' // 支付宝payId
// export const WX_PAY_ID = '10001' // 微信payId

// 其他支付类型方式
// export const OTHER_PAY_WAY = {
//   [ZFB_PAY_ID]: 'zfb',
//   [WX_PAY_ID]: 'wx'
// }

/*
 * 获取token
 * */
export var getAuthToken = function getAuthToken() {
  return new Promise(function (resolve) {
    // 本地token是否存在
    var token = auth.getToken();
    if (token) {
      resolve(token);
    } else {
      // app内直接通过app获取token
      if (appInfo) {
        // 兼容ios获取token
        var tempToken = '';
        if (appInfo.ecopyright === 'ios' && CompareVersion(appInfo.version, '2.7.10')) {
          setTimeout(function () {
            if (!tempToken) {
              resolve('');
            }
          }, 1000);
        }
        App.getToken({}, function () {
          var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          tempToken = token;
          resolve(token);
        });
      } else {
        resolve('');
      }
    }
  });
};

/*
 * 初始化支付通道
 * */
export var initPayChannel = function initPayChannel(data) {
  if (data && data[0] && data[0].channelList && data[0].channelList[0]) {
    var channel = data[0].channelList[0];
    var channelType = data[0].channelType;
    var key = {
      1: 'wallet',
      2: 'bankCard',
      3: 'thirdPartyPaymentChannel'
    };
    var channelTypePaymentKey = {
      FUIOU_PAY: 'balance',
      YEE_PAY: 'YeeWalletPay',
      OTHER: 'zfb'
    };
    var param = _objectSpread(_objectSpread({}, channel[key[channel.subChannelType]]), {}, {
      way: channelTypePaymentKey[channelType]
    });
    store.commit('user/SET_PAY_CHANNEL_LIST', data);
    store.commit('user/SET_DEFAULT_PAY_CHANNEL', param);
    auth.lsSetPayChannelList(data);
    auth.lsSetDefaultPayChannel(param);
    return param;
  }
  return null;
};